'use strict';

/**
 * Warehouse controller
 */
angular.module('scrapQcrmApp')
  .controller('WarehousesCtrl', function ($scope, tableState, $rootScope, $global, $uibModal, $window, $state, growl, $log, warehouseService, $stateParams, DTOptionsBuilder, DTColumnDefBuilder, $moment, $timeout) {

    /*===============================================init values===================================================*/
    $scope.labelCounts = {
      totalWarehouses: 0,
      activeWarehouses: 0,
      inActiveWarehouses: 0
    };
    $scope.resetLabelCounts = function () {
      $scope.labelCounts = {
        totalWarehouses: 0,
        activeWarehouses: 0,
        inActiveWarehouses: 0
      };
    };
    (function () {
      $scope.pages = -1;
      $scope.vm = { params: { "city": $rootScope.loginData.city } };
      $scope.currentPage = 1;

      $scope.dateInput = $moment().format("DD-MMM-YYYY");
      $scope.date = {
        startDate: $scope.dateInput,
        endDate: $scope.dateInput
      };

      $rootScope.loginData = {};
      $rootScope.loginData = $global.getLocalItem("loginData", true);

      $scope.opts = {
        format: "DD-MMM-YYYY",
        singleDatePicker: true
      };

      $scope.customIcon = {
        "scaledSize": [32, 32],
        "url": "http://www.cliparthut.com/clip-arts/823/arrowhead-clip-art-823528.png"
      };

      $scope.currentPage = 1;

      $scope.date = {
        startDate: $moment().subtract(730, 'd').format("DD-MMM-YYYY"),
        endDate: $moment().format("DD-MMM-YYYY")
      };

      $scope.statusFilter = 'ACTIVE'; // ALL | ACTIVE | INACTIVE

      $scope.setStatusFilter = function (filter) {
        $scope.statusFilter = filter;
        var filtered = $scope.warehouse_list || [];
        if (filter === 'ACTIVE') {
          filtered = filtered.filter(function (w) { return w.enabled !== false; });
        } else if (filter === 'INACTIVE') {
          filtered = filtered.filter(function (w) { return w.enabled === false; });
        }
        if ($scope.gridOptions && $scope.gridOptions.api) {
          $scope.gridOptions.api.setRowData(filtered);
        }
      };

      var columnDefs = [
        {
          headerName: "Warehouse Name",
          field: "warehouseName",
        },
        {
          headerName: "Mobile Number",
          cellRenderer: HideMobileNumber,
        },
        {
          headerName: "Warehouse Type",
          field: "warehouseType",
          cellStyle: { 'text-align': 'center' }
        },
        {
          headerName: "Owner",
          field: "warehouseTypeValue",
          cellStyle: { 'text-align': 'center' }
        },
        {
          headerName: "City",
          field: "city",
          cellStyle: { 'text-align': 'center' }
        },
        {
          headerName: "Inception Date",
          field: "createdOn",
          cellStyle: { 'text-align': 'center' }
        },
        {
          headerName: "Status",
          field: "enabled",
          cellStyle: { 'text-align': 'center' },
          cellRenderer: function (params) {
            var isInactive = params.value === false;
            var color = isInactive ? '#f44336' : '#4caf50';
            var label = isInactive ? 'Inactive' : 'Active';
            return '<span style="color:' + color + ';font-weight:600;">' + label + '</span>';
          }
        },
        {
          headerName: "Area",
          field: "area",
          hide: true
        },
        {
          headerName: "Latitude",
          field: "address.latitude",
          hide: true
        },
        {
          headerName: "Longitude",
          field: "address.longitude",
          hide: true
        }
      ];

      let rowData = [];

      $scope.gridOptions = {
        columnDefs: columnDefs,
        defaultColDef: {
          flex: 1,
          minWidth: 150,
          filter: true,
          sortable: true,
          resizable: true
        },
        suppressCsvExport: true,
        suppressExcelExport: true,
        rowStyle: { background: '#f4f4f4' },
        pagination: true,
        paginationPageSize: 50,
        // rowModelType: 'serverSide',
        // serverSideStoreType: 'partial',
        // cacheBlockSize: 50,
        rowData: rowData,
        // suppressPaginationPanel:true,
        getRowStyle: function (params) {
          if (params.data && params.data.enabled === false) {
            return { background: '#fce4e4', color: '#999' };
          }
          if (params.node.rowIndex % 2 === 0) {
            return { background: 'white' };
          }
        },
        onGridReady: function (params) {
          // params.api.sizeColumnsToFit();
          // params.columnApi.autoSizeAllColumns();
          $scope.gridOptions.api.setRowData($scope.warehouse_list);

        },
        onCellClicked: function (event) {
          if (warehousesTable && warehousesTable.isModifiedClick(event)) {
            warehousesTable.openInNewTab(event.data.warehouseId); // Ctrl / Cmd click: details in a new tab
            return;
          }
          $scope.warehouseDetails(event.data.warehouseId);
        },
        onFirstDataRendered: function (params) {
          params.api.sizeColumnsToFit();
        }
      };



      //Inventory Grid
      var inventoryColDef = [
        {
          headerName: "Items Name",
          field: "categoryName",
          cellStyle: { textAlign: 'left' },
        },
        {
          headerName: "+ Incoming ScrapQ Inventory (kgs)",
          field: "vendorName",
          cellStyle: { textAlign: 'right' },
          valueFormatter: function (params) {
            return params.data.incomingInventory.toFixed(2);
          }
        },
        {
          headerName: "+ Incoming Warehouse Inventory (kgs)",
          field: "saleOrderConfirmationId",
          cellStyle: { textAlign: 'right' },
          valueFormatter: function (params) {
            return params.data.toWarehouseTransportInventory.toFixed(2);
          }

        },
        {
          headerName: "- Outgoing ScrapQ Inventory (kgs)",
          field: "totalAmount",
          cellStyle: { textAlign: 'right' },
          valueFormatter: function (params) {
            return params.data.incomingInventory.toFixed(2);
          }
        },
        {
          headerName: "- Outgoing Warehouse Inventory (kgs)",
          field: "status",
          cellStyle: { textAlign: 'right' },
          valueFormatter: function (params) {
            return params.data.outgoingInventory.toFixed(2);
          }
        },
        {
          headerName: "= Current Inventory (kgs)",
          field: "createdOn",
          cellStyle: { textAlign: 'right' },
          valueFormatter: function (params) {
            return params.data.currentInventory.toFixed(2);
          }
        }
      ];

      $scope.inventoryGridOptions = {
        columnDefs: inventoryColDef,
        defaultColDef: {
          flex: 1,
          minWidth: 150,
          filter: true,
          sortable: true,
          resizable: true
        },
        suppressCsvExport: true,
        suppressExcelExport: true,
        rowStyle: { background: '#f4f4f4' },
        pagination: true,
        rowData: [],
        paginationPageSize: 50,
        getRowStyle: function (params) {
          if (params.node.rowIndex % 2 === 0) {
            return { background: 'white' };
          }
        },
        onGridReady: function (params) {
          setTimeout(function () {
            if ($scope.inventoryGridOptions && $scope.inventoryGridOptions.api) {
              $scope.inventoryGridOptions.api.setRowData($scope.currentInventory_list);
            }
          }, 1500);
        },
        onCellClicked: function (event) {
        },
        onFirstDataRendered: function (params) {
          params.api.sizeColumnsToFit();
        }
      };
    })();


    // All / Active / Inactive, the grid (filters, sort, page) and the open warehouse are kept in the URL
    // (a warehouse login sees only its own warehouse: nothing to keep there)
    var warehousesTable = $rootScope.loginData.role === "WAREHOUSEUSER" ? null : tableState.page($scope, 'w', {
      controls: {
        s: {
          model: 'statusFilter', type: 'string',
          validate: function (v) { return ['ALL', 'ACTIVE', 'INACTIVE'].indexOf(v) >= 0; },
          onRestore: function (v) { $scope.setStatusFilter(v); }
        }
      },
      grids: { g: 'gridOptions' },
      record: {
        model: 'warehouseId',
        open: function (id) { $scope.warehouseDetails(id); },
        close: function () { loadWarehouses(); }
      }
    });

    (function () {
      if ($rootScope.loginData.role === "CRMUSER" || $rootScope.loginData.role === "ADMIN" || $rootScope.loginData.role === "MASTERFRANCHISE" || $rootScope.loginData.role === "WHOLESALER") {
        if (!warehousesTable || !warehousesTable.recordInUrl()) { // a warehouse opened from the URL loads the list when going back
          loadWarehouses($scope.vm.params);
        }
      } else if ($rootScope.loginData.role === "WAREHOUSEUSER") {
        $scope.length0 = true;
        $scope.warehouseId = $rootScope.loginData.warehouseId;
        getWarehouseProfile($scope.warehouseId);
        $scope.warehouse_list = false;
      } else {
        console.error('Invalid authorized role details ', $rootScope.loginData);
      }
    })();

    /*===============================================core function===================================================*/


    //Hide mobile number of the Customers to all except for Super Admin and CRM User
    function HideMobileNumber() {
    }
    HideMobileNumber.prototype.init = function (params) {
      this.mobileNumberDiv = document.createElement('div');
      if (params.data != "" || params.data != "undefined") {
        var rawMobile = (params.data.mobile || '').replace(/\D/g, '').substring(0, 11);
        if ($rootScope.loginData.role == "ADMIN" || $rootScope.loginData.role == "CRMUSER") {
          this.mobileNumberDiv.innerHTML = "<div>" + rawMobile + "</div>";
        } else {
          var hiddenMobileNo = rawMobile.slice(0, 2) + rawMobile.slice(2).replace(/.(?=...)/g, '*');
          this.mobileNumberDiv.innerHTML = "<div>" + hiddenMobileNo + "</div>";
        }
      } else {
        this.mobileNumberDiv.innerHTML = "";
      }
    }

    HideMobileNumber.prototype.getGui = function () {
      return this.mobileNumberDiv;
    }

    $scope.$watch('dateInput', function (newDate) {
      $scope.transactionChange();
    }, false);

    $scope.transactionChange = function () {
      $scope.date.startDate = $moment($scope.dateInput).format("DD-MMM-YYYY");
      $scope.date.endDate = $moment($scope.dateInput).format("DD-MMM-YYYY");
      $scope.noCurrentInventory = true;
      if ($scope.warehouseId) {
        $scope.currentInventory($scope.warehouseId, $scope.date.startDate, $scope.date.endDate);
      }
    };

    $scope.nextDate = function () {
      $scope.paging = false;
      $scope.dateInput = $moment($scope.dateInput).add(1, "days").format("DD-MMM-YYYY");
      $scope.date = {
        startDate: $scope.dateInput,
        endDate: $scope.dateInput,
      };
    };

    $scope.previousDate = function () {
      $scope.paging = false;
      $scope.dateInput = $moment($scope.dateInput).subtract(1, "days").format("DD-MMM-YYYY");
      $scope.date = {
        startDate: $scope.dateInput,
        endDate: $scope.dateInput,
      };
    };

    $scope.currentInventory = function (warehouseId, fromDate, toDate) {
      $scope.noCurrentInventory = true;
      $scope.currentInventory_list = [];
      warehouseService.retrieveAllInventories(warehouseId, toDate, $rootScope.loginData.city, $scope.currentPage)
        .then(function (res) {
          if (res.status === "SUCCESS") {
            if (res.data.allInventories.length > 0) {
              $scope.noCurrentInventory = false;
              $scope.currentInventory_list = res.data.allInventories;
              $scope.inventoryGridOptions.api.setRowData($scope.currentInventory_list);

              $scope.totalInventoriesRecords = res.data.totalRecords;
            } else {
              $scope.noCurrentInventory = true;
            }
          }
        })
        .catch(function (err) {
          console.error('Error in warehouseService.retrieveAllInventories() ', err);
        })
    };

    $scope.pageChangedCompletedTransactions = function (currentPage) {
      $scope.currentPage = currentPage;
      $scope.currentInventory($scope.warehouseId, $scope.date.startDate, $scope.date.endDate);
    };

    $scope.searchWarehouse = function (key) {
      key = key.trim();
      if (key) {
        const type = 'WAREHOUSE';
        $scope.submitted = true;
        $scope.paging = true;
        $scope.noWarehouseFound = false;

        if (key.length > 3) {
          warehouseService.searchWarehouse(type, key)
            .then(function (res) {
              if (res.status === "SUCCESS") {
                $scope.warehouses = res.data;
                if (res.data.warehouses.length === 1) {
                  $scope.length0 = true;
                  $scope.warehouseDetails(res.data.warehouses[0].warehouseId);
                } else {
                  res.data.warehouses.forEach(function (elem, idx) {
                    try {
                      const addrsplit = elem.address.formattedAddress.split(/,+/);
                      res.data.warehouses[idx]['area'] = addrsplit[addrsplit.length - 4].trim() + ", " + addrsplit[addrsplit.length - 3].trim();
                    } catch (e) {
                      console.error('Error in formatting address ', e);
                    }
                  });
                  $scope.warehouse_list = res.data.warehouses;
                  $scope.length0 = false;
                  $scope.warehouseId = false;
                }
                if (res.data.message === "No records found") {
                  $scope.noWarehouseFound = true;
                }
              } else if (res.status === "FAILURE") {
                $scope.noWarehouseFound = true;
              } else {
                $scope.noWarehouseFound = true;
              }
            })
            .catch(function (err) {
              console.error('Error in warehouseService.searchWarehouse() ', err);

            })
        }
      } else {
        loadWarehouses($scope.vm.params);
      }
    };

    $scope.cleanMobile = function (mobile) {
      return (mobile || '').replace(/\D/g, '').substring(0, 11);
    };

    $scope.toggleWarehouseStatus = function () {
      var warehouse = $scope.profileEdit;
      var isInactive = warehouse.enabled === false;
      var action = isInactive ? 'enable' : 'disable';
      if (confirm('Are you sure you want to ' + action + ' ' + warehouse.warehouseName + '?')) {
        // disable → send mobile; enable → send warehouseId (_id, never changes)
        var payload = isInactive
          ? { id: warehouse.warehouseId, enabled: true }
          : { id: warehouse.mobile, enabled: false };

        warehouseService.toggleWarehouseStatus(payload).then(function (res) {
          if (res.status === "SUCCESS") {
            growl.success(res.data.message);
            $scope.warehouseId = false;
            $scope.length0 = false;
            $scope.profileEdit = null;
            $scope.vm.params = { city: $rootScope.loginData.city };
            $timeout(function () {
              loadWarehouses($scope.vm.params);
            }, 1500);
          } else if (res.status === "FAILURE") {
            growl.error(res.error.message);
          } else {
            $scope.warehouseId = false;
            $scope.length0 = false;
            $scope.vm.params = { city: $rootScope.loginData.city };
            loadWarehouses($scope.vm.params);
          }
        }, function (err) {
          console.error('Error in toggleWarehouseStatus API ', err);
          growl.error('Failed to ' + action + ' warehouse');
        });
      }
    };

    /*===============================================helper function===================================================*/

    $scope.pageChanged = function (currentPage) {
      $scope.vm.params.page = currentPage;
      loadWarehouses($scope.vm.params);
    };

    $scope.warehouseDetails = function (id) {
      // find the warehouse in the already-loaded list to check enabled state
      var warehouseFromList = null;
      if ($scope.warehouse_list && $scope.warehouse_list.length) {
        for (var i = 0; i < $scope.warehouse_list.length; i++) {
          if ($scope.warehouse_list[i].warehouseId === id) {
            warehouseFromList = $scope.warehouse_list[i];
            break;
          }
        }
      }

      $scope.length0 = true;
      $scope.warehouseId = id;
      $scope.warehouse_list = false;
      $scope.date = {
        startDate: $moment().subtract(730, 'd').format("DD-MMM-YYYY"),
        endDate: $moment().format("DD-MMM-YYYY")
      };
      $scope.vm.params = {
        "warehouse": id,
        "size": 10,
        "page": 0,
      };

      if (warehouseFromList && warehouseFromList.enabled === false) {
        $scope.profileEdit = warehouseFromList;
        $scope.noCurrentInventory = true;
        $scope.currentInventory_list = [];
      } else {
        // active warehouse — fetch full profile normally
        getWarehouseProfile(id);
        $scope.currentInventory($scope.warehouseId, $scope.date.startDate, $scope.date.endDate);
      }
    };

    function getWarehouseProfile(warehouseId) {
      warehouseService.getProfile(warehouseId)
        .then(function (res) {
          if (res.status === "SUCCESS") {
            $scope.profileEdit = res.data.warehouse;
            $scope.centerdata = {
              "latitude": parseFloat($scope.profileEdit.address.latitude),
              "longitude": parseFloat($scope.profileEdit.address.longitude)
            };
            $scope.center = new google.maps.LatLng(parseFloat($scope.profileEdit.address.latitude), parseFloat($scope.profileEdit.address.longitude));
            const mapOptions = {
              zoom: 17,
              mapTypeId: 'roadmap',
              center: $scope.center
            };
            $scope.map = new google.maps.Map(document.getElementById('map'), mapOptions);
            const icon = {
              url: "/images/pulse.gif",
              scaledSize: new google.maps.Size(30, 30),
              origin: new google.maps.Point(0, 0),
              anchor: new google.maps.Point(15, 15)
            };
            const marker = new google.maps.Marker({
              position: $scope.center,
              map: $scope.map,
              icon: icon
            });
            $scope.length0 = true;
          } else if (res.status === "FAILURE") {
            if (!$scope.profileEdit) {
              $scope.noWarehouseFound = "No warehouse record found";
            }
          }
        })
        .catch(function (err) {
          console.error('Error in getWarehouseProfile() ', err);
        })
    }

    function loadWarehouses(params) {
      $global.displayLog("loadWarehouses");
      const type = 'WAREHOUSE';
      $scope.submitted = true;
      $scope.paging = false;
      $scope.noWarehouseFound = false;
      $scope.warehouse_list = [];

      if (!params || !params.page) {
        params = {};
        params.page = 1;
      }
      let noDecrement = params.page === -1;
      // ag-grid pagination to work we need all records. -1 fetches all records
      params.page = -1;

      var activeReq = warehouseService.warehousesLoad(type, params.page, noDecrement, 'active');
      var inactiveReq = warehouseService.warehousesLoad(type, params.page, noDecrement, 'inactive');

      Promise.all([activeReq, inactiveReq]).then(function (results) {
        var activeRes = results[0];
        var inactiveRes = results[1];
        var activeWarehouses = [];
        var inactiveWarehouses = [];

        if (activeRes.status === "SUCCESS") {
          activeWarehouses = activeRes.data.warehouses || [];
          activeWarehouses.forEach(function (w) { w.enabled = true; });
          activeWarehouses.forEach(function (elem, idx) {
            try {
              if (elem.address) {
                const addrsplit = elem.address.formattedAddress.split(/,+/);
                activeWarehouses[idx]['area'] = addrsplit[addrsplit.length - 4].trim() + ", " + addrsplit[addrsplit.length - 3].trim();
              }
            } catch (e) { console.error('Error in formatting address ', e); }
          });
          $scope.labelCounts = {
            totalWarehouses: activeRes.data.totalWarehouses,
            activeWarehouses: activeRes.data.totalActiveWarehouses,
            inActiveWarehouses: activeRes.data.totalInactiveWarehouses
          };
        }

        if (inactiveRes.status === "SUCCESS") {
          inactiveWarehouses = inactiveRes.data.warehouses || [];
          inactiveWarehouses.forEach(function (w) { w.enabled = false; });
          inactiveWarehouses.forEach(function (elem, idx) {
            try {
              if (elem.address) {
                const addrsplit = elem.address.formattedAddress.split(/,+/);
                inactiveWarehouses[idx]['area'] = addrsplit[addrsplit.length - 4].trim() + ", " + addrsplit[addrsplit.length - 3].trim();
              }
            } catch (e) { console.error('Error in formatting address ', e); }
          });
          if (activeRes.status !== "SUCCESS") {
            $scope.labelCounts = {
              totalWarehouses: inactiveRes.data.totalWarehouses,
              activeWarehouses: inactiveRes.data.totalActiveWarehouses,
              inActiveWarehouses: inactiveRes.data.totalInactiveWarehouses
            };
          }
        }

        $scope.length0 = false;
        $scope.warehouseId = false;
        $scope.warehouse_list = activeWarehouses.concat(inactiveWarehouses);
        $scope.totalWarehouseRecords = $scope.warehouse_list.length;

        if ($scope.gridOptions && $scope.gridOptions.api) {
          $scope.setStatusFilter($scope.statusFilter || 'ALL');
        }

        if ($scope.warehouse_list.length === 0) {
          $scope.noWarehouseFound = true;
        }
      }).catch(function (err) {
        $scope.resetLabelCounts();
        console.error('Error in loadWarehouses() ', err);
      });
    }

    // Back on the details: like the browser Back (the list comes back as it was)
    $scope.backClick = function () {
      if (warehousesTable) {
        warehousesTable.backFromRecord();
      } else {
        loadWarehouses();
      }
    };

    $scope.refreshClick = function () {
      loadWarehouses();
    };

    /*===============================================modal functions===================================================*/

    $scope.selectPage = function () {

    };

    $scope.addWarehouses = function () {

      $state.go("root.add-warehouse");


      // const modalInstance = $uibModal.open({
      //   templateUrl: 'views/add-warehouse.html',
      //   controller: 'AddWarehouseCtrl',
      //   size: "lg",
      //   resolve: {
      //     items: function () {
      //       return 'WAREHOUSE';
      //     }
      //   }
      // });
      // modalInstance.result.then(function (selectedItem) {
      //   $scope.selected = selectedItem;
      // }, function () {
      //   loadWarehouses($scope.vm.params);
      // });
    };

    $scope.editWarehouseDetails = function () {

      $state.go("root.edit-warehouse", { id: $scope.profileEdit.warehouseId })



      // const modalInstance = $uibModal.open({
      //   templateUrl: 'views/warehouse-edit-profile.html',
      //   controller: 'WarehouseEditProfileCtrl',
      //   size: "lg",
      //   resolve: {
      //     items: function () {
      //       return $scope.profileEdit.warehouseId;
      //     }
      //   }
      // });
      // modalInstance.result.then(function (selectedItem) {
      //   $scope.selected = selectedItem;
      // }, function () {
      //   getWarehouseProfile($scope.warehouseId);
      // });
    };

  });

